module.exports = __webpack_public_path__ + "img/dykning.5081081f.jpg";